import { Children } from "react";
const deepMapChildren = (children, callback) => {
  Children.map(children, child => child?.props?.children ? [callback(child), deepMapChildren(child.props.children, callback)] : callback(child));
};
export default deepMapChildren;